/**
 * Created by rafael on 10.03.17.
 */
import React from 'react';
import { connect } from 'react-redux';
import { Button, DropdownButton, MenuItem } from 'react-bootstrap';
import {
  setPrintStatus,
  changePrintOrientation,
  printingTriggered,
  changePrintToPdfStatus,
} from '../../../actions/printSettings';
import LayersModal from '../LayersModal';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PrintModal.scss';

const mapState = state => ({
  printOrientation: state.printSettings.printOrientation,
  windowViewport: state.printSettings.windowViewport,
  fontSize: state.runtime.fontSize,
  intl: state.intl
});

const mapDispatch = {
  setPrintStatus,
  changePrintOrientation,
  printingTriggered,
  changePrintToPdfStatus,
};

class PrintModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      printPaperFormat: 'A4',
      printPaperOrientation: this.props.printOrientation,
      printWindowPosition: {},
      layersShowed: false,
    };
  }
  componentDidMount = () => {
    const printWindow = document.getElementsByClassName('printWindow')[0];
    const printWindowPosition = printWindow.getBoundingClientRect();
    this.setState({ printWindowPosition });
  }
  setSelectedOrientation = value => {
    this.setState({ printPaperOrientation: value })
    this.props.changePrintOrientation(value);
  }
  handleSubmit = () => {
      window.print();
      this.props.onMove();
      this.props.printingTriggered();
  }
  handleReset = () => {
    this.props.onMove();
    this.props.setPrintStatus();
  }
  showLayers = () => {
    this.setState({ layersShowed: !this.state.layersShowed });
  }
  onClickPDF = () => {
    this.props.changePrintToPdfStatus(true);
  }
  render() {
    const layersShowed = this.state.layersShowed ? "layers-list show" : "layers-list";
    return (
      <div
        style={this.state.printWindowPosition.bottom > this.props.windowViewport.height ?
          { overflowY: 'scroll', height: this.props.windowViewport.height - this.state.printWindowPosition.top }
          : null}
        className={'navPopups panel panel-default absolute-popup printWindow'}
        onMouseOver={() => this.props.offMove()}
        onMouseOut={() => this.props.onMove()}
      >
        <style type="text/css">
          {`@media print{@page {size: ${this.props.printOrientation === 'pionowo' ? 'portrait' : 'landscape'}}`}
        </style>
        <div className={'panel-heading'}>{this.props.intl.langKeys.podgladWydruku}</div>
        <div className={'panel-body'}>
          <div className={'col-sm-12'}>
            <h3 style={{ fontSize: this.props.fontSize + 0.4 + 'rem', textAlign: 'center' }}>{this.props.intl.langKeys.ustawieniaDruku}</h3>

            <div>
              <label htmlFor="layer_from" className={'spacer'}>{this.props.intl.langKeys.orientacja}: </label>
              <DropdownButton
                title={this.state.printPaperOrientation}
                key={0}
                id="bg-justified-dropdown"
                onSelect={(eventKey) => this.setSelectedOrientation(eventKey)}
              >
                <MenuItem eventKey={'pionowo'}>{this.props.intl.langKeys.pionowo}</MenuItem>
                <MenuItem eventKey={'poziomo'}>{this.props.intl.langKeys.poziomo}</MenuItem>
              </DropdownButton>
              <div className={'buttons'}>
                <Button
                    className={'spacer'}
                    bsStyle={'primary'}
                    onClick={this.onClickPDF}
                >
                  {this.props.intl.langKeys.generujPdf}
                </Button>
                <Button
                  className={'spacer'}
                  bsStyle={'primary'}
                  onClick={this.handleSubmit}
                >{this.props.intl.langKeys.generujWydruk}
                </Button>
                <Button
                  bsStyle={'danger'}
                  onClick={this.handleReset}
                >{this.props.intl.langKeys.anuluj}
                </Button>
              </div>
              <Button
                bsStyle={'default'}
                className="layers-button"
                onClick={this.showLayers}
              >
                {this.props.intl.langKeys.wybierzWarstwy}
              </Button>
            </div>
            {/*Here comes the printMap from MapControl.js*/}
            {/* <div>
              {this.props.children}
            </div> */}
            {/*<div>
              <label htmlFor="layer_from">Format</label>
              <DropdownButton
                title={this.state.printPaperFormat}
                key={1}
                id="bg-justified-dropdown"
                onSelect={(eventKey) => this.setSelectedFormat(eventKey)}
              >
                <MenuItem eventKey={'A4'}>A4</MenuItem>
                <MenuItem eventKey={'A3'}>A3</MenuItem>
              </DropdownButton>
            </div>*/}
            
            
            <div className={layersShowed}>
              <LayersModal />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(connect(mapState, mapDispatch)(PrintModal));



// WEBPACK FOOTER //
// src/components/Modals/PrintModal/PrintModal.js